import {Pipe, PipeTransform} from '@angular/core';
import * as moment from 'moment';

@Pipe({
  name: 'getDate'
})
export class getDatePipe implements PipeTransform {

  transform(dateData: any, time: boolean = false, shortTime: boolean = false, age : any = false): any {
    if(!dateData) return "";
    if(dateData == "0000-00-00") return "";
    let dt = null;
    const getAge = function(dob) {
      let today = new Date();
      let birthDate = new Date(dob);
      let age = today.getFullYear() - birthDate.getFullYear();
      let m = today.getMonth() - birthDate.getMonth();
      if (m < 0 || (m === 0 && today.getDate() < birthDate.getDate())) {
        age--;
      }
      return isNaN(age)?"--":age;
    }
    if(age){
      return getAge(dateData);
    }
    if(shortTime)
      dt = moment(new Date(dateData)).format("DD MMM, YYYY HH:mm");
    else if(time)
      dt = moment(new Date(dateData)).format("DD MMM, YYYY hh:mm:ss A");
    else 
      dt = moment(new Date(dateData)).format("DD MMM, YYYY"); 
    return dt;
  }

}
